import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import Switcher from "../utils/header/LanguageSwitcher";
import "../../styles/components/blocks/Menu.scss";
import gsap from "gsap";
import { CustomEase } from "gsap/all";
import eventBus from "../../utils/eventBus";
import imagesLoaded from "imagesloaded";

// Import images dor each element of the menu
import AboutImageDesk from "../../images/menu/desktop/image_about.jpg";
import AccueilImageDesk from "../../images/menu/desktop/image_acceuil.jpg";
import ContactImageDesk from "../../images/menu/desktop/image_contact.jpg";
import EventImageDesk from "../../images/menu/desktop/image_evenement.jpg";
import ActivitiesImageDesk from "../../images/menu/desktop/image_activities.jpg";
import LesSuitesImageDesk from "../../images/menu/desktop/image_les_suites.jpg";
import RestaurationImageDesk from ".././../images/menu/desktop/image_restauration.jpg";

import AboutImageDeskRetina from "../../images/menu/desktop/image_about@2x.jpg";
import AccueilImageDeskRetina from "../../images/menu/desktop/image_acceuil@2x.jpg";
import ContactImageDeskRetina from "../../images/menu/desktop/image_contact@2x.jpg";
import EventImageDeskRetina from "../../images/menu/desktop/image_evenement@2x.jpg";
import ActivitiesImageDeskRetina from "../../images/menu/desktop/image_activities@2x.jpg";
import LesSuitesImageDeskRetina from "../../images/menu/desktop/image_les_suites.jpg";
import RestaurationImageDeskRetina from ".././../images/menu/desktop/image_restauration@2x.jpg";

import AboutImageDeskS from "../../images/menu/desktop/image_about_s.jpg";
import AccueilImageDeskS from "../../images/menu/desktop/image_acceuil_s.jpg";
import ContactImageDeskS from "../../images/menu/desktop/image_contact_s.jpg";
import EventImageDeskS from "../../images/menu/desktop/image_evenement_s.jpg";
import ActivitiesImageDeskS from "../../images/menu/desktop/image_activities_s.jpg";
import LesSuitesImageDeskS from "../../images/menu/desktop/image_les_suites_s.jpg";
import RestaurationImageDeskS from ".././../images/menu/desktop/image_restauration_s.jpg";

import AboutImageDeskSRetina from "../../images/menu/desktop/image_about_s@2x.jpg";
import AccueilImageDeskSRetina from "../../images/menu/desktop/image_acceuil_s@2x.jpg";
import ContactImageDeskSRetina from "../../images/menu/desktop/image_contact_s@2x.jpg";
import EventImageDeskSRetina from "../../images/menu/desktop/image_evenement_s@2x.jpg";
import ActivitiesImageDeskSRetina from "../../images/menu/desktop/image_activities_s@2x.jpg";
import LesSuitesImageDeskSRetina from "../../images/menu/desktop/image_les_suites_s@2x.jpg";
import RestaurationImageDeskSRetina from ".././../images/menu/desktop/image_restauration_s@2x.jpg";

import AboutImageDeskWebp from "../../images/menu/desktop/image_about.jpg";
import AccueilImageDeskWebp from "../../images/menu/desktop/image_acceuil.jpg";
import ContactImageDeskWebp from "../../images/menu/desktop/image_contact.jpg";
import EventImageDeskWebp from "../../images/menu/desktop/image_evenement.jpg";
import ActivitiesImageDeskWebp from "../../images/menu/desktop/image_activities.jpg";
import LesSuitesImageDeskWebp from "../../images/menu/desktop/image_les_suites.jpg";
import RestaurationImageDeskWebp from ".././../images/menu/desktop/image_restauration.jpg";

import AboutImageDeskWebpRetina from "../../images/menu/desktop/image_about@2x.jpg";
import AccueilImageDeskWebpRetina from "../../images/menu/desktop/image_acceuil@2x.jpg";
import ContactImageDeskWebpRetina from "../../images/menu/desktop/image_contact@2x.jpg";
import EventImageDeskWebpRetina from "../../images/menu/desktop/image_evenement@2x.jpg";
import ActivitiesImageDeskWebpRetina from "../../images/menu/desktop/image_activities@2x.jpg";
import LesSuitesImageDeskWebpRetina from "../../images/menu/desktop/image_les_suites@2x.jpg";
import RestaurationImageDeskWebpRetina from ".././../images/menu/desktop/image_restauration@2x.jpg";

import AboutImageDeskSWebp from "../../images/menu/desktop/image_about_s.jpg";
import AccueilImageDeskSWebp from "../../images/menu/desktop/image_acceuil_s.jpg";
import ContactImageDeskSWebp from "../../images/menu/desktop/image_contact_s.jpg";
import EventImageDeskSWebp from "../../images/menu/desktop/image_evenement_s.jpg";
import ActivitiesImageDeskSWebp from "../../images/menu/desktop/image_activities_s.jpg";
import LesSuitesImageDeskSWebp from "../../images/menu/desktop/image_les_suites_s.jpg";
import RestaurationImageDeskSWebp from ".././../images/menu/desktop/image_restauration_s.jpg";

import AboutImageDeskSWebpRetina from "../../images/menu/desktop/image_about_s@2x.jpg";
import AccueilImageDeskSWebpRetina from "../../images/menu/desktop/image_acceuil_s@2x.jpg";
import ContactImageDeskSWebpRetina from "../../images/menu/desktop/image_contact_s@2x.jpg";
import EventImageDeskSWebpRetina from "../../images/menu/desktop/image_evenement_s@2x.jpg";
import ActivitiesImageDeskSWebpRetina from "../../images/menu/desktop/image_activities_s@2x.jpg";
import LesSuitesImageDeskSWebpRetina from "../../images/menu/desktop/image_les_suites_s@2x.jpg";
import RestaurationImageDeskSWebpRetina from ".././../images/menu/desktop/image_restauration_s@2x.jpg";


// Create a fullscreen menu
const Menu = ({ path }) => {
  // if path contains /en all links will be in english
  // else all links will be in french
  const [getWindow, setWindow] = React.useState()
  const [lastRoute, setLastRoute] = React.useState();
  const [type, setType] = React.useState(null);
  const closeMenu = (route) => {
    if (getWindow.location.href.includes(route)) {
      eventBus.dispatch("closeMenuAnimation");
    }
  }


  const resizeOps = () => {
    // document.documentElement.style.setProperty("--vh", window.innerHeight * 0.01 + "px");
    gsap.set('.bi_fullscreen_menu', { height: window.innerHeight });
    // window.scrollTo(0, 0);
  };



  const [bgImageUrl, setBgImageUrl] = useState();
  const lang = path.includes("/en") ? "/en" : "";
  const [hovered, setHovered] = useState(false);
  const imageChangeHover = (e) => {
    gsap.registerPlugin(CustomEase);
    // if a link or li is hovered the image will change for the equivalent index of picture html tag
    // ex: if the index is 0, the image will change to the first picture
    const index = e.target.getAttribute("index");
    const picture = document.querySelectorAll(
      ".bi_fullscreen_menu_gallery > picture:nth-child(" + index + ")"
    );
    const pictureLittle = document.querySelectorAll(
      ".bi_fullscreen_menu_gallery div > picture:nth-child(" + index + ")"
    );
    gsap.killTweensOf(picture);
    gsap.killTweensOf(".bi_fullscreen_menu_gallery picture:nth-child(" + index + ") img");
    gsap.set([picture, pictureLittle], { display: 'block' });

    let tl = gsap.timeline();
    tl.fromTo(
      picture,
      { 
        opacity: 1,
        x: "-100vw",
        zIndex: 10,
        visibility: "initial" 
      },{
        opacity: 1,
        x: 0,
        visibility: "initial",
        zIndex: 10,
        ease: CustomEase.create("custom", "M0,0 C0.11,0.494 0.13,0.756 0.256,0.882 0.388,1.014 0.504,1 1,1 "),
        duration: 2,
      }
    );
    tl.fromTo(
      pictureLittle,
      { 
        opacity: 1,
        x: "-100vw",
        zIndex: 10,
        visibility: "initial"
      }, {
        opacity: 1,
        x: 0,
        visibility: "initial",
        zIndex: 10,
        ease: CustomEase.create("custom", "M0,0 C0.11,0.494 0.13,0.756 0.256,0.882 0.388,1.014 0.504,1 1,1 "),
        duration: 1.5,
      }, "0.3"
    );
    tl.fromTo(
      ".bi_fullscreen_menu_gallery > picture:nth-child(" + index + ") img",{ 
        x: "100vw",
        scale: 1
      }, { 
        x: 0,
        scale: 1.2,
        ease: CustomEase.create("custom", "M0,0 C0.11,0.494 0.13,0.756 0.256,0.882 0.388,1.014 0.504,1 1,1 "),
        duration: 2
      }, "0"
    );
    tl.fromTo(
      ".bi_fullscreen_menu_gallery div > picture:nth-child(" + index + ") img", { 
        x: "100vw",
        scale: 1 
      }, { 
        x: 0, 
        scale: 1.2, 
        ease: CustomEase.create("custom", "M0,0 C0.11,0.494 0.13,0.756 0.256,0.882 0.388,1.014 0.504,1 1,1 "), 
        duration: 1.5
      }, "0.3"
    );
  };

  const hideImageLeaveHover = (e) => {
    // if a link or li is hovered the image will change for the equivalent index of picture html tag
    // ex: if the index is 0, the image will change to the first picture
    const index = e.target.getAttribute("index");
    const picture = document.querySelectorAll(
      ".bi_fullscreen_menu_gallery picture:nth-child(" + index + ")"
    );

    gsap.killTweensOf(picture);
    gsap.killTweensOf(".bi_fullscreen_menu_gallery picture:nth-child(" + index + ") img");
    gsap.fromTo(
      picture,
      { 
        opacity: 1,
        x: 0, 
        visibility: "initial", 
        zIndex: 8
      },
      {
        opacity: 1,
        x: "100vw",
        zIndex: 8,
        visibility: "initial",
        duration:3
      }
    );

    gsap.fromTo(
      ".bi_fullscreen_menu_gallery picture:nth-child(" + index + ") img",
      { 
        x: 0 
      },
      { 
        x: "-100vw", 
        duration: 3
      }
    );
  };

  const currentBackgroundImage = () => {
    let imageUrl;
    let imageUrlS;
    switch (path) {
      case "/":
        imageUrl = AccueilImageDesk;
        break;
      case "/activities":
        imageUrl = ActivitiesImageDesk;
        break;
      case "/restauration":
        imageUrl = RestaurationImageDesk;
        break;
      case "/les_suites":
        imageUrl = LesSuitesImageDesk;
        break;
      case "/contact":
        imageUrl = ContactImageDesk;
        break;
      case "/a_propos":
        imageUrl = AboutImageDesk;
        break;
      case "/activities/":
        imageUrl = ActivitiesImageDesk;
        break;
      case "/restauration/":
        imageUrl = RestaurationImageDesk;
        break;
      case "/les_suites/":
        imageUrl = LesSuitesImageDesk;
        break;
      case "/contact/":
        imageUrl = ContactImageDesk;
        break;
      case "/a_propos/":
        imageUrl = AboutImageDesk;
        break;
      case "/en":
        imageUrl = AccueilImageDesk;
        break;
      case "/en/activities":
        imageUrl = ActivitiesImageDesk;
        break;
      case "/en/restauration":
        imageUrl = RestaurationImageDesk;
        break;
      case "/en/les_suites":
        imageUrl = LesSuitesImageDesk;
        break;
      case "/en/contact":
        imageUrl = ContactImageDesk;
        break;
      case "/en/a_propos":
        imageUrl = AboutImageDesk;
        break;
      case "/en/":
        imageUrl = AccueilImageDesk;
        break;
      case "/en/activities/":
        imageUrl = ActivitiesImageDesk;
        break;
      case "/en/restauration/":
        imageUrl = RestaurationImageDesk;
        break;
      case "/en/les_suites/":
        imageUrl = LesSuitesImageDesk;
        break;
      case "/en/contact/":
        imageUrl = ContactImageDesk;
        break;
      case "/en/a_propos/":
        imageUrl = AboutImageDesk;
        break;
      default:
        imageUrl = AccueilImageDesk;
    }
    setBgImageUrl(imageUrl);
  };

  const onMouseOverFunc = () => {
    setHovered(true);
  };

  const initTimeLine = (state) => {
    let tl = gsap.timeline({
      onReverseComplete: () => {
        eventBus.dispatch("pageAppear", { lastRoute: state, wP: window.location.pathname });
       /* if (window.innerWidth < 770 && state !== window.location.pathname) {
          setTimeout(()=>{
            window.scrollTo(0, 0);
          }, 1)
        } */
      },
      onComplete: () => {
        resizeOps();
        window.addEventListener("resize", resizeOps);
        currentBackgroundImage();
        setLastRoute(window.location.pathname);
      }
    });
    tl.fromTo(
      ".bi_fullscreen_menu",
      { opacity: 1, height: 0 },
      { opacity: 1, height: window.innerHeight + 'px' }
    );
    tl.fromTo(
      ".bi_fullscreen_menu_content li",
      { opacity: 0, y: -10 },
      { opacity: 1, stagger: 0.1, duration: 0.3, y: 0, delay: "-=0.2" }
    );
    tl.fromTo(
      ".bi_fullscreen_menu_gallery",
      { opacity: 0 },
      { opacity: 1, duration: 0.3 },
      "<"
    );

    eventBus.on("closeMenuAnimation", () => {
      tl.reverse();
    });
    eventBus.on("enableScroll", () => {
      imagesLoaded("main", () => {
        tl.reverse();
      });
    });
  }

  useEffect(() => {
    currentBackgroundImage();
    setLastRoute(window.location.pathname);
    setLastRoute(state => {
      initTimeLine(state)
      return state;
    })

    setWindow(window)

  }, []);

  return (
    <div className="bi_fullscreen_menu">
      <div className="bi_fullscreen_menu_content">
        <ul>
          <li>
            <Link
              to={lang + "/a_propos"}
              index="1"
              onMouseEnter={(e) => imageChangeHover(e)}
              onMouseLeave={(e) => hideImageLeaveHover(e)}
              onMouseMove={(e) => onMouseOverFunc(e)}
              onClick={() => closeMenu("/a_propos")}
            >
              {" "}
              {lang === "/en" ? "About" : "À propos"}
            </Link>
          </li>
          <li>
            <Link
              to={lang + "/les_suites"}
              index="2"
              onMouseEnter={(e) => imageChangeHover(e)}
              onMouseLeave={(e) => hideImageLeaveHover(e)}
              onMouseMove={(e) => onMouseOverFunc(e)}
              onClick={() => closeMenu("/les_suites")}
            >
              {lang === "/en" ? "The suites" : "Les Suites"}
            </Link>
          </li>
          <li>
            <Link
              to={lang + "/restauration"}
              index="3"
              onMouseEnter={(e) => imageChangeHover(e)}
              onMouseLeave={(e) => hideImageLeaveHover(e)}
              onMouseMove={(e) => onMouseOverFunc(e)}
              onClick={() => closeMenu("/restauration")}
            >
              {lang === "/en" ? "Food" : "Restauration"}
            </Link>
          </li>
          <li>
            <Link
              to={lang + "/activities"}
              index="4"
              onMouseEnter={(e) => imageChangeHover(e)}
              onMouseLeave={(e) => hideImageLeaveHover(e)}
              onMouseMove={(e) => onMouseOverFunc(e)}
              onClick={() => closeMenu("/activities")}

            >
              {lang === "/en" ? "Activities" : "Activités"}
            </Link>
          </li>
          <li>
            <Link
              to={lang + "/evenement"}
              index="5"
              onMouseEnter={(e) => imageChangeHover(e)}
              onMouseLeave={(e) => hideImageLeaveHover(e)}
              onMouseMove={(e) => onMouseOverFunc(e)}
              onClick={() => closeMenu("/evenement")}

            >
              {lang === "/en" ? "Events" : "Événements"}
            </Link>
          </li>
          <li>
            <Link
              to={lang + "/contact"}
              index="6"
              onMouseEnter={(e) => imageChangeHover(e)}
              onMouseLeave={(e) => hideImageLeaveHover(e)}
              onMouseMove={(e) => onMouseOverFunc(e)}
              onClick={() => closeMenu("/contact")}

            >
              {lang === "/en" ? "Contact and access" : "Contact et accès"}
            </Link>
          </li>
        </ul>
        <ul className="bi_social_link">
          <li>
            <a
              href="https://www.facebook.com/lessuitesdelilebarbe"
              target="_blank"
            >
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  className="circle"
                  cx="18"
                  cy="18"
                  r="17.5"
                  fill="#D7D7D7"
                />
                <circle cx="18" cy="18" r="17.5" stroke="#D7D7D7" />
                <path
                  d="M24.0001 10.6665H12.0001C11.2634 10.6665 10.6667 11.2632 10.6667 11.9998V23.9998C10.6667 24.7365 11.2634 25.3332 12.0001 25.3332H18.6667V19.3332H16.6667V17.3332H18.6667V16.2592C18.6667 14.2258 19.6574 13.3332 21.3474 13.3332C22.1567 13.3332 22.5847 13.3932 22.7874 13.4205V15.3332H21.6347C20.9174 15.3332 20.6667 15.7118 20.6667 16.4785V17.3332H22.7694L22.4841 19.3332H20.6667V25.3332H24.0001C24.7367 25.3332 25.3334 24.7365 25.3334 23.9998V11.9998C25.3334 11.2632 24.7361 10.6665 24.0001 10.6665Z"
                  fill="#F8F4F2"
                />
              </svg>
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/company/lessuitesdelilebarbe/"
              target="_blank"
            >
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="18"
                  cy="18"
                  r="18"
                  fill="#D7D7D7"
                  className="circle"
                />
                <circle cx="18" cy="18" r="18" stroke="#D7D7D7" />
                <path
                  d="M20.8005 10.1333H11.2005C10.6111 10.1333 10.1338 10.6106 10.1338 11.2V20.8C10.1338 21.3893 10.6111 21.8666 11.2005 21.8666H20.8005C21.3898 21.8666 21.8671 21.3893 21.8671 20.8V11.2C21.8671 10.6106 21.3898 10.1333 20.8005 10.1333ZM13.8426 19.7333H12.2693V14.6709H13.8426V19.7333ZM13.0399 13.9472C12.5327 13.9472 12.1226 13.536 12.1226 13.0298C12.1226 12.5237 12.5333 12.113 13.0399 12.113C13.5455 12.113 13.9567 12.5242 13.9567 13.0298C13.9567 13.536 13.5455 13.9472 13.0399 13.9472ZM19.7359 19.7333H18.1637V17.2714C18.1637 16.6842 18.153 15.929 17.3461 15.929C16.5274 15.929 16.4015 16.5685 16.4015 17.2288V19.7333H14.8293V14.6709H16.3386V15.3626H16.3599C16.5701 14.9648 17.0831 14.545 17.8485 14.545C19.4415 14.545 19.7359 15.5936 19.7359 16.9568V19.7333V19.7333Z"
                  fill="#F8F4F2"
                  style={{ transform: "translate(-4px, -5px) scale(1.4)" }}
                />
              </svg>
            </a>
          </li>
          <li>
            <a
              href="https://www.instagram.com/lessuitesdelilebarbe/"
              target="_blank"
            >
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  className="circle"
                  cx="18"
                  cy="18"
                  r="17.5"
                  fill="#D7D7D7"
                />
                <circle cx="18" cy="18" r="17.5" stroke="#D7D7D7" />
                <path
                  d="M14.6667 10.5C12.3692 10.5 10.5 12.3692 10.5 14.6667V21.3333C10.5 23.6308 12.3692 25.5 14.6667 25.5H21.3333C23.6308 25.5 25.5 23.6308 25.5 21.3333V14.6667C25.5 12.3692 23.6308 10.5 21.3333 10.5H14.6667ZM14.6667 12.1667H21.3333C22.7117 12.1667 23.8333 13.2883 23.8333 14.6667V21.3333C23.8333 22.7117 22.7117 23.8333 21.3333 23.8333H14.6667C13.2883 23.8333 12.1667 22.7117 12.1667 21.3333V14.6667C12.1667 13.2883 13.2883 12.1667 14.6667 12.1667ZM22.1667 13C21.9457 13 21.7337 13.0878 21.5774 13.2441C21.4211 13.4004 21.3333 13.6123 21.3333 13.8333C21.3333 14.0543 21.4211 14.2663 21.5774 14.4226C21.7337 14.5789 21.9457 14.6667 22.1667 14.6667C22.3877 14.6667 22.5996 14.5789 22.7559 14.4226C22.9122 14.2663 23 14.0543 23 13.8333C23 13.6123 22.9122 13.4004 22.7559 13.2441C22.5996 13.0878 22.3877 13 22.1667 13ZM18 13.8333C15.7025 13.8333 13.8333 15.7025 13.8333 18C13.8333 20.2975 15.7025 22.1667 18 22.1667C20.2975 22.1667 22.1667 20.2975 22.1667 18C22.1667 15.7025 20.2975 13.8333 18 13.8333ZM18 15.5C19.3783 15.5 20.5 16.6217 20.5 18C20.5 19.3783 19.3783 20.5 18 20.5C16.6217 20.5 15.5 19.3783 15.5 18C15.5 16.6217 16.6217 15.5 18 15.5Z"
                  fill="#F8F4F2"
                />
              </svg>
            </a>
          </li>
          <li>
            <a href="">
              <Switcher path={path} />
            </a>
          </li>
        </ul>
      </div>
      <div
        className="bi_fullscreen_menu_gallery"
        style={{
          backgroundOrigin: "content-box",
          backgroundSize: "cover",
          backgroundImage:
            "url(" +
            AccueilImageDesk +
            ")",
          color: "red",
        }}
      >
        <picture>
          <source
            type="image/webp"
            srcSet={AboutImageDeskWebpRetina + " 2x," + AboutImageDeskWebp + " 1x"}
          />
          <source
            type="image/jpeg"
            srcSet={AboutImageDeskRetina + " 2x," + AboutImageDesk + " 1x"}
          />
          <img src={AboutImageDesk} alt="" sizes="" srcset="" />
        </picture>
        <picture>
          <source
            type="image/webp"
            srcSet={LesSuitesImageDeskWebpRetina + " 2x," + LesSuitesImageDeskWebp + " 1x"}
          />
          <source
            type="image/jpeg"
            srcSet={LesSuitesImageDeskRetina + " 2x," + LesSuitesImageDesk + " 1x"}
          />
          <img src={LesSuitesImageDesk} alt="" sizes="" srcset="" />
        </picture>
        <picture>
          <source
            type="image/webp"
            srcSet={RestaurationImageDeskWebpRetina + " 2x," + RestaurationImageDeskWebp + " 1x"}
          />
          <source
            type="image/jpeg"
            srcSet={RestaurationImageDeskRetina + " 2x," + RestaurationImageDesk + " 1x"}
          />
          <img src={RestaurationImageDesk} alt="" sizes="" srcset="" />
        </picture>
        <picture>
          <source
            type="image/webp"
            srcSet={ActivitiesImageDeskWebpRetina + " 2x," + ActivitiesImageDeskWebp + " 1x"}
          />
          <source
            type="image/jpeg"
            srcSet={ActivitiesImageDeskRetina + " 2x," + ActivitiesImageDesk + " 1x"}
          />
          <img src={ActivitiesImageDesk} alt="" sizes="" srcset="" />
        </picture>
        <picture>
          <source
            type="image/webp"
            srcSet={EventImageDeskWebpRetina + " 2x," + EventImageDeskWebp + " 1x"}
          />
          <source
            type="image/jpeg"
            srcSet={EventImageDeskRetina + " 2x," + EventImageDesk + " 1x"}
          />
          <img src={EventImageDesk} alt="" sizes="" srcset="" />
        </picture>
        <picture>
          <source
            type="image/webp"
            srcSet={ContactImageDeskWebpRetina + " 2x," + ContactImageDeskWebp + " 1x"}
          />
          <source
            type="image/jpeg"
            srcSet={ContactImageDeskRetina + " 2x," + ContactImageDesk + " 1x"}
          />
          <img src={ContactImageDesk} alt="" sizes="" srcset="" />
        </picture>
        <div style={{
          backgroundOrigin: "content-box",
          backgroundSize: "cover",
          backgroundImage:
            "url(" +
            AccueilImageDeskS +
            ")",
          color: "red",
        }}>
          <picture>
            <source
              type="image/webp"
              srcSet={AboutImageDeskSWebpRetina + " 2x," + AboutImageDeskSWebp + " 1x"}
            />
            <source
              type="image/jpeg"
              srcSet={AboutImageDeskSRetina + " 2x," + AboutImageDeskS + " 1x"}
            />
            <img src={AboutImageDeskS} alt="" sizes="" srcset="" />
          </picture>
          <picture>
            <source
              type="image/webp"
              srcSet={LesSuitesImageDeskSWebpRetina + " 2x," + LesSuitesImageDeskSWebp + " 1x"}
            />
            <source
              type="image/jpeg"
              srcSet={LesSuitesImageDeskSRetina + " 2x," + LesSuitesImageDeskS + " 1x"}
            />
            <img src={LesSuitesImageDeskS} alt="" sizes="" srcset="" />
          </picture>
          <picture>
            <source
              type="image/webp"
              srcSet={RestaurationImageDeskSWebpRetina + " 2x," + RestaurationImageDeskSWebp + " 1x"}
            />
            <source
              type="image/jpeg"
              srcSet={RestaurationImageDeskSRetina + " 2x," + RestaurationImageDeskS + " 1x"}
            />
            <img src={RestaurationImageDeskS} alt="" sizes="" srcset="" />
          </picture>
          <picture>
            <source
              type="image/webp"
              srcSet={ActivitiesImageDeskSWebpRetina + " 2x," + ActivitiesImageDeskSWebp + " 1x"}
            />
            <source
              type="image/jpeg"
              srcSet={ActivitiesImageDeskSRetina + " 2x," + ActivitiesImageDeskS + " 1x"}
            />
            <img src={ActivitiesImageDeskS} alt="" sizes="" srcset="" />
          </picture>
          <picture>
            <source
              type="image/webp"
              srcSet={EventImageDeskSWebpRetina + " 2x," + EventImageDeskSWebp + " 1x"}
            />
            <source
              type="image/jpeg"
              srcSet={EventImageDeskSRetina + " 2x," + EventImageDeskS + " 1x"}
            />
            <img src={EventImageDeskS} alt="" sizes="" srcset="" />
          </picture>
          <picture>
            <source
              type="image/webp"
              srcSet={ContactImageDeskSWebpRetina + " 2x," + ContactImageDeskSWebp + " 1x"}
            />
            <source
              type="image/jpeg"
              srcSet={ContactImageDeskSRetina + " 2x," + ContactImageDeskS + " 1x"}
            />
            <img src={ContactImageDeskS} alt="" sizes="" srcset="" />
          </picture>
        </div>
      </div>
    </div>
  );
};

export default Menu;
